

/***************** Timeline Scripts ******************/
var timelineTop;
var StartPositionHeight = $('.pagination-start').outerHeight();
function initTimeline() {
  //initialize swiper when document ready
  if ($('.timeline-slide-wrapper').length) {
    $('html').css('overflow-y','hidden');
    var timelineTop = new Swiper ('.timeline-slide-wrapper', {
      // Optional parameters
      direction: 'horizontal',
      loop: false,
      slidesPerView: 3,
      centeredSlides: true,
      paginationClickable: true,
      pagination: '.swiper-pagination',
      paginationBulletRender: function (swiper, index, className) {
        var slideYear = $('.timeline-slide-wrapper .swiper-slide').eq(index).data('year');
        return '<span class="' + className + '" data-year="' + slideYear + '"></span>';
      },
      spaceBetween: 40,
      mousewheelControl: true,
      onScroll: function (swiper,event) {
        var timeout = null;
        var speed = 100; //ms
        var canScroll = true;
          if (timeout !== null) {
              event.preventDefault();
              return false;
          }

          // Get scroll delta, check for the different kind of event indexes regarding delta/scrolls
          var delta = event.originalEvent.detail ? event.originalEvent.detail * (-120) : (
                  event.originalEvent.wheelDelta ? event.originalEvent.wheelDelta : (
                          event.originalEvent.deltaY ? (event.originalEvent.deltaY * 1) * (-120) : 0
          ));

          // Get direction
          var scrollDown = delta < 0;

          // This is where you do something with scrolling and reset the timeout
          // If the container can be scrolling, be sure to prevent the default mouse action
          // otherwise the parent container can scroll too
          if (canScroll) {
              timeout = setTimeout(function(){timeout = null;}, speed);
              event.preventDefault();
              return false;
          }

          // Container couldn't scroll, so let the parent scroll
          return true;
      },
      //mousewheelForceToAxis: true,
    //  mousewheelInvert: true,
    //  mousewheelSensitivity: 2,
    //  mousewheelReleaseOnEdges: true,
      breakpoints: {
        // when window width is <= 1024px
        1023: {
          slidesPerView: 1,
          spaceBetween: 10
        },
        1024: {
          slidesPerView: 2,
          spaceBetween: 10
        },
      }
    });
    //initialize swiper when document ready
    if ($('.timeline-years-wrapper').length) {
      var timelineBottom = new Swiper ('.timeline-years-wrapper', {
        // Optional parameters
        direction: 'horizontal',
        loop: false,
        centeredSlides: true,
        slidesPerView: '3',
        touchRatio: 0.2,
        slideToClickedSlide: true,
        spaceBetween: 40,
        mousewheelControl: true,
        onScroll: function (swiper,event) {
          var timeout = null;
          var speed = 100; //ms
          var canScroll = true;
            if (timeout !== null) {
                event.preventDefault();
                return false;
            }

            // Get scroll delta, check for the different kind of event indexes regarding delta/scrolls
            var delta = event.originalEvent.detail ? event.originalEvent.detail * (-120) : (
                    event.originalEvent.wheelDelta ? event.originalEvent.wheelDelta : (
                            event.originalEvent.deltaY ? (event.originalEvent.deltaY * 1) * (-120) : 0
            ));

            // Get direction
            var scrollDown = delta < 0;

            // This is where you do something with scrolling and reset the timeout
            // If the container can be scrolling, be sure to prevent the default mouse action
            // otherwise the parent container can scroll too
            if (canScroll) {
                timeout = setTimeout(function(){timeout = null;}, speed);
                event.preventDefault();
                return false;
            }

            // Container couldn't scroll, so let the parent scroll
            return true;
        },
        breakpoints: {
          // when window width is <= 1024px
          1023: {
            slidesPerView: 3,
            spaceBetween: 10
          },
          1024: {
            slidesPerView: 2,
            spaceBetween: 10
          },
        }
      });
      timelineTop.params.control = timelineBottom;
      timelineBottom.params.control = timelineTop;

      if (Foundation.MediaQuery.atLeast('large')) {
        setTimeout( function() {
          bulletHeight = $('body').find('.swiper-pagination-bullet-active').outerHeight();
          var ActiveBulletPosition = $('.swiper-pagination-bullet.swiper-pagination-bullet-active').position();
          var ActiveBulletTop = ActiveBulletPosition.top;
          var FinalPosition = StartPositionHeight + ActiveBulletTop + (bulletHeight*0.5) - 10;
          $('#pagination-current').css('top',FinalPosition + 'px');
          console.log('bulletHeight ' + bulletHeight + ' - ActiveBulletTop ' + ActiveBulletTop + ' - FinalPosition ' + FinalPosition);
        }, 500);
        // Add one more handler for this event
        timelineTop.on('slideChangeStart', function () {
            //console.log('slide change');
            bulletHeight = $('body').find('.swiper-pagination-bullet-active').outerHeight();
            var ActiveBullet = $('.swiper-pagination-bullet.swiper-pagination-bullet-active');
            var ActiveBulletPosition = ActiveBullet.position();
            var ActiveBulletTop = ActiveBulletPosition.top;
            //var FinalPosition = ActiveBulletTop + (bulletHeight*0.5) + 10;
            var FinalPosition = StartPositionHeight + ActiveBulletTop + (bulletHeight*0.5) - 10;
            var ActiveBulletText = ActiveBullet.data('year');
            //var StartPositionHeight = $('.pagination-start').outerHeight();
            $('#pagination-current').css('top',FinalPosition + 'px'); // minus 15 to center on pagination line
            $('#pagination-current').html(ActiveBulletText);
        });
      }
      // Drag stuff
      var bulletHeight,slideNumber;

      if (Foundation.MediaQuery.atLeast('large')) {
        setTimeout( function() {
        var totalBullets = $('body').find('.swiper-pagination-bullet').length;
        console.log('totalBullets ' + totalBullets);
        console.log('initDrag');
        var element = document.getElementById('pagination-current'),
          x = 0, y = 0;
        bulletHeight = $('body').find('.swiper-pagination-bullet-active').outerHeight();
        console.log('bulletHeight: ' +bulletHeight);
        interact(element)
          .draggable({
            snap: {
              targets: [
                interact.createSnapGrid({ y: bulletHeight })
                /*function (x, y) {
                  console.log('bulletHeight: ' + bulletHeight);
                  interact.createSnapGrid({ x: 30, y: bulletHeight })
                }*/
              ],
              range: Infinity,
          //    relativePoints: [ { x: 0, y: 0 } ]
            },
            inertia: true,
            restrict: {
              restriction: 'parent',
            }
          })
          .on('dragmove', function (event) {
            x += event.dx;
            y += event.dy;
            elementNumber = 1 + y/bulletHeight;
            if (elementNumber>totalBullets || elementNumber<1) {
              // Do nothing
            } else {
              elementOffset = 10*elementNumber;
              slideNumber = elementNumber-1;
              var slideYear = $('.timeline-slide-wrapper').find('.swiper-slide').eq(slideNumber).data('year');
              console.log('elementNumber: ' + elementNumber);
              endPosition = StartPositionHeight + y + elementOffset + (bulletHeight*0.5) ;
            //  var FinalPosition = StartPositionHeight + ActiveBulletTop + - 10;
              event.target.style.webkitTransform =
              event.target.style.top = endPosition + 'px';
              $(event.target).html(slideYear);
              console.log('Y: ' + y);
              console.log('dy: ' + event.dy);
              console.log('endPosition: ' + endPosition);
            }
          })
          .on('dragend', function(event) {
            elementNumber = 1 + y/bulletHeight;
            slideNumber = elementNumber-1;
              timelineTop.slideTo(slideNumber);
          });
        }, 500);
      }
    }
  }
}

// underscore's throttle-metod

function debounce(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        }, wait);
        if (immediate && !timeout) func.apply(context, args);
    };
};

/*
Old code:
$(window).scroll(function(e) {
// whatever
});
*/

// new code, break out scroll handler:




$(document).ready(function () {

  initTimeline();

  /***************** Cater for scroll issues with Mac Magic Mouse ******************/


/*
  $(window).on('DOMMouseScroll mousewheel wheel', function(event) {
      // Timeout active? do nothing
      if (timeout !== null) {
          event.preventDefault();
          return false;
      }

      // Get scroll delta, check for the different kind of event indexes regarding delta/scrolls
      var delta = event.originalEvent.detail ? event.originalEvent.detail * (-120) : (
              event.originalEvent.wheelDelta ? event.originalEvent.wheelDelta : (
                      event.originalEvent.deltaY ? (event.originalEvent.deltaY * 1) * (-120) : 0
      ));

      // Get direction
      var scrollDown = delta < 0;

      // This is where you do something with scrolling and reset the timeout
      // If the container can be scrolling, be sure to prevent the default mouse action
      // otherwise the parent container can scroll too
      if (canScroll) {
          timeout = setTimeout(function(){timeout = null;}, speed);
          event.preventDefault();
          return false;
      }

      // Container couldn't scroll, so let the parent scroll
      return true;
  });*/


  //setTimeout( function() {
  //  initDrag();
//  }, 500);
  $('#timeline-how-to').on('click', function() {
    $('#timeline-how-to').fadeOut();
  });
  $('.swiper-pagination-wrapper').on('click', function() {
    $('#timeline-how-to').fadeOut();
  });
  $('#timeline-how-to').on('mousewheel',function() { //.box is the class of the div
    $('#timeline-how-to').fadeOut();
  });

});
